class ApiService {
  constructor() {
 //   this.baseURL = 'http://localhost:8090'; 
      this.baseURL = 'https://api.poster.realtyhub.cy'; //http://localhost:8090
  }

  async makeRequest(endpoint, method, body = null) {
    const headers = new Headers();
    const uData = localStorage.getItem('user-data');

    // Add Authorization header if user data exists
    if (uData) {
      const { token } = JSON.parse(uData);
      if (token) {
        headers.append('Authorization', `Bearer ${token}`);
      }
    }

    // Set Content-Type for JSON payloads
    if (method.toUpperCase() !== 'GET' && body && !(body instanceof FormData) ) {
      headers.append('Content-Type', 'application/json');
    }

    // Prepare request options
    const requestOptions = {
      method: method.toUpperCase(), // Ensure method is uppercase
      headers: headers,
      credentials: 'include', // Include cookies for cross-origin requests
    };

    // Add body if provided
    if (body) {
      requestOptions.body = body instanceof FormData ? body : JSON.stringify(body);
    }

    try {
      const response = await fetch(`${this.baseURL}${endpoint}`, requestOptions);

      // Handle unauthorized responses
      if (response.status === 401) {
        console.warn("Unauthorized! Redirecting to login...");
        window.location.href = '/'; // Redirect to login or handle auth flow
        throw new Error('Unauthorized');
      }

      // Handle non-success responses
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        // localStorage.clear()
        // window.location.href = '/'; // Redirect to login or handle auth flow
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
       
      }

      // Handle empty responses
      const contentLength = response.headers.get('content-length');
      if (contentLength === '0' || response.status === 204) {
        return null;
      }

      // Parse and return JSON response
      return await response.json();
    } catch (error) {
      console.error('API Error:', error);
      throw error; // Re-throw to allow caller to handle
    }
  }

  async get(endpoint) {
    return this.makeRequest(endpoint, 'GET');
  }

  async delete(endpoint) {
    return this.makeRequest(endpoint, 'DELETE');
  }

  async post(endpoint, body) {
    return this.makeRequest(endpoint, 'POST', body);
  }

  // New PUT method
  async put(endpoint, body) {
    return this.makeRequest(endpoint, 'PUT', body);
  }
}

export default new ApiService();
